import { CommonModule, DatePipe } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { CustomerProfileCoreModule } from "@guest-web/core";
import { LoggingModule } from "@guest-web/logging";

import { environment } from "../../environments/environment";
import { AuthenticationModule } from "../authentication/authentication.module";
import { CustomerProfileFacadeService } from "../profile/profile-facade.service";

import { LayoutFacadeService } from "./components/layout/layout-facade.service";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { ResizeDetectorDirective } from "./directives/resize-detector.directive";
import { LoadApplicationGuard } from "./guards/load-application.guard";
import { LoadMainApplicationGuard } from "./guards/load-main-application.guard";
import { AppEventQueueService } from "./services/app-event-queue.service";
import { CommonFacadeService } from "./services/common-facade.service";
import { CompanyFacadeService } from "./services/company-facade.service";
import { CustomerFacadeService } from "./services/customer-facade.service";
import { DialogModule } from "./services/dialog/dialog.module";
import { LocalStorageService } from "./services/local-storage.service";
import { NavigationFacadeService } from "./services/navigation-facade.service";
import { SessionStorageService } from "./services/session-storage.service";
import { SizeDetectorFacadeService } from "./services/size-detector-facade.service";

const COMPONENTS = [];

const DIRECTIVES = [ResizeDetectorDirective];

const FACADES = [
	SizeDetectorFacadeService,
	NavigationFacadeService,
	CompanyFacadeService,
	CustomerFacadeService,
	CommonFacadeService,
	AppEventQueueService,
	LayoutFacadeService,
	CustomerProfileFacadeService,
];

const GUARDS = [LoadApplicationGuard, LoadMainApplicationGuard];

const MAPPERS = [];

@NgModule({
	imports: [
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		RouterModule,
		DialogModule,
		LoggingModule.forRoot({
			url: environment.logUrl,
			environment: environment.production ? "prod" : "dev",
			application: environment.channel,
			logLevel: environment.logLevel,
			serverLogLevel: environment.serverLogLevel,
		}),
		AuthenticationModule,
		PageNotFoundComponent,
		...COMPONENTS,
		...DIRECTIVES,
		CustomerProfileCoreModule,
	],
	exports: [...COMPONENTS, ...DIRECTIVES],
	providers: [
		...FACADES,
		...GUARDS,
		...MAPPERS,
		DatePipe,
		SessionStorageService,
		LocalStorageService,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule {}
